export { default } from './SearchPanel';
